export enum PermissionEnum {
  ROLE_CONTENT_MANAGER_PERMISSION = 'ROLE_CONTENT_MANAGER_PERMISSION',
  ROLE_ORDER_MANAGER_PERMISSION = 'ROLE_ORDER_MANAGER_PERMISSION',
  ALL_PERMISSION = 'ALL_PERMISSION'
}


